export default function EntryAmountField({ currency, amount, autoFocus, onChange }: {
  currency: string; amount: string; autoFocus: boolean; onChange: (value: string) => void;
}) {
  return <label className="expense-amount">Amount <span>{currency}</span>
    <input name="amount" aria-label={`Amount in ${currency}`} inputMode="decimal" autoFocus={autoFocus}
      value={amount} onChange={event => onChange(event.target.value)} placeholder="0.00"
      pattern="[0-9]+([.][0-9]{1,2})?" required maxLength={12} />
  </label>;
}
